import { toast } from 'react-toastify';
import type { Id, UpdateOptions } from 'react-toastify';

/**
 * Updates an active toast in place — content via `render`, and any toast
 * options. Passing `autoClose` restarts the dismiss timer. No-op if no toast
 * with the given id is active.
 */
export function updateToast(toastId: Id, options: UpdateOptions): void {
  toast.update(toastId, options);
}

/** Returns whether a toast with the given id is currently displayed. */
export function isToastActive(toastId: Id): boolean {
  return toast.isActive(toastId);
}
